import PrimaryButton from "components/buttons/primary-button";
import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import PatternImg from "images/png/rated-playlist-background-pattern.png";
import PageBanner from "images/png/pitch-easy.png";
import { ReactComponent as PitchHeartSvg } from "images/svg/pitch_heart.svg";
import { ReactComponent as Arrow } from "images/svg/arrowRight.svg";

const PageHeader = () => {
  return (
    <Header>
      <BgHeader src={PatternImg} alt="bg-pattern" />
      <HeaderPart>
        <Typography
          color={Colors.white100}
          size="4xl"
          weight="bold"
          m_size="xl"
          mb="3.2"
          m_mb="1.9"
        >
          Pitch Easy
        </Typography>

        <Typography
          color={Colors.white100}
          size="6rem"
          weight="bold"
          m_size="4xl"
          mb="1.6"
        >
          Get Your Music in Front of the Right People
        </Typography>
        <Typography size="2xl" color={Colors.grey500} mb="3.2">
          With{" "}
          <span style={{ color: Colors.grey100, fontWeight: 500 }}>
            Pitch Easy
          </span>{" "}
          , you get the ultimate toolkit to pitch your music to industry
          professionals, build your{" "}
          <span style={{ color: Colors.grey100, fontWeight: 500 }}>
            Electronic Press Kit (EPK),
          </span>{" "}
          and access expert{" "}
          <span style={{ color: Colors.grey100, fontWeight: 500 }}>
            PR strategies
          </span>{" "}
          all in one place.
        </Typography>
        <CTAContainer>
          <div>
            <Typography size="xl" weight="medium">
              Pitch Your Music Like a Pro & Get Noticed, only for:
            </Typography>
            <div style={{ display: "inline-flex", alignItems: "end" }}>
              <Typography
                size="4rem"
                m_size="4xl"
                weight="bold"
                color={Colors.primary}
              >
                $99.99{" "}
              </Typography>
              <Typography
                color={Colors.grey100}
                size="lg"
                m_size="m"
                mb="1"
                ml="1"
                m_mb="0.5"
              >
                {" "}
                one time payment
              </Typography>
            </div>
          </div>
          <CTABtnContainer>
            <PrimaryButton
              onClick={() => {
                // navigate("/overview/promo-cards/create");
              }}
              text="Get Started"
              icon={<Arrow />}
              inset
              sparkle
              iconPosition="right"
              fitContent
              iconSize="2"
            />
          </CTABtnContainer>
          <CTASvg>
            <PitchHeartSvg />
          </CTASvg>
        </CTAContainer>
      </HeaderPart>
      <HeaderPart>
        <Banner src={PageBanner} alt="promo -banner" />
      </HeaderPart>
    </Header>
  );
};

export default PageHeader;

const Header = styled.section`
  display: grid;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  grid-template-columns: 48% 50%;
  padding-bottom: 18rem;
  position: relative;

  @media only screen and (max-width: 769px) {
    grid-template-columns: 100%;
    padding-bottom: 1rem;
  }
`;

const BgHeader = styled.img`
  position: absolute;
  width: 100%;
  top: 0%;
  @media only screen and (max-width: 769px) {
    height: 100%;
    width: 350%;
    top: 0%;
    left: -10%;
  }
`;

const HeaderPart = styled.div`
  position: relative;
`;

const Banner = styled.img`
  position: absolute;
  height: 60rem;
  top: -19rem;
  left: 0;

  @media only screen and (max-width: 769px) {
    position: relative;
    top: 0;
    left: -9rem;
    height: 55rem;
  }
`;

const CTAContainer = styled.div`
  width: 90%;
  position: relative;
  border-radius: 1.1rem;
  padding: 1.4rem 2.4rem;
  overflow: hidden;
  border: 1px solid #4e4e4e;
  background: linear-gradient(106deg, #131313 1.36%, #5b5b5b 100%);
  display: grid;
  grid-template-columns: 50% 50%;
  align-items: center;
  justify-content: space-between;

  @media only screen and (max-width: 769px) {
    width: 100%;
    grid-template-columns: 70%;
    grid-row-gap: 2rem;
    padding: 1.4rem;
  }
`;

const CTABtnContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  width: 100%;
  z-index: 2;
  @media only screen and (max-width: 769px) {
    justify-content: flex-start;
  }
`;

const CTASvg = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  z-index: 0;
`;
